export const englishTranslations = {
  'language.label': 'Language',
  'language.english': 'English',
  'language.spanish': 'Spanish',
  'common.actions': 'Actions',
  'common.cancel': 'Cancel',
  'common.close': 'Close',
  'common.error': 'Error!',
  'common.failed': 'Failed',
  'common.loading': 'Loading',
  'common.save': 'Save',
  'common.success': 'Success!',
  'common.unknown': 'Unknown',
  'common.user': 'User',
  'common.unknownCompany': 'Unknown company',
  'nav.home': 'Home',
  'nav.primary': 'Primary navigation',
  'nav.rigWell': 'Rig-Well',
  'nav.testResults': 'Test Results',
  'nav.centrifugeReports': 'Centrifuge Reports',
  'nav.importedFiles': 'Imported Files',
  'header.createApiToken': 'Create API Token',
  'header.companySettings': 'Company-level settings',
  'header.oneClickMudCheck': 'One-Click Mud Check',
  'header.uploadCsv': 'Upload CSV',
  'header.downloadDesktopApp': 'Download desktop app',
  'header.downloadingDesktopApp': 'Downloading desktop app…',
  'header.downloadDesktopAppError': 'Desktop app download failed. Try again.',
  'header.logout': 'Logout',
  'header.calibration': 'Calibration',
  'header.qc': 'QC',
  'header.qcThresholds': 'QC thresholds',
  'header.qcThresholdsDescription':
    'Company-level QC limits used for new results. Existing results are not recalculated.',
  'header.oilCalibration': 'Oil % calibration',
  'header.waterCalibration': 'Water % calibration',
  'header.oilCalibrationDescription':
    'Subtracts this many percentage points from predicted oil % for new results generated for this company. Existing results are not recalculated.',
  'header.waterCalibrationDescription':
    'Subtracts this many percentage points from predicted water % for new results generated for this company. Existing results are not recalculated.',
  'header.resetDefault': 'Reset to default',
  'header.resetFieldDefault': 'Reset {{field}} to default',
  'header.loadSettingsError': 'Failed to load company settings.',
  'header.saveSettingsError': 'Failed to save company settings.',
  'header.numberError': '{{label}} calibration must be a number.',
  'header.rangeError': '{{label}} calibration must be between -100 and 100.',
  'header.fieldNumberError': '{{field}} must be a number.',
  'header.fieldMinError': '{{field}} must be at least {{min}}.',
  'header.fieldMaxError': '{{field}} must be at most {{max}}.',
  'header.warningBandDescription':
    '0.15 means 15% of the distance between low and high limits.',
  'header.apiTokenTitle': 'Create API Token',
  'header.apiTokenError': 'Failed to create API token.',
  'header.apiTokenDescription':
    'Paste this token into the Qt app API settings Auth Token field.',
  'header.copied': 'Copied',
  'header.copyToken': 'Copy token',
  'login.title': 'Log in',
  'login.subtitle': 'Welcome back. Please enter your details.',
  'login.name': 'Name',
  'login.password': 'Password',
  'login.signIn': 'Sign In',
  'login.missingCredentials': 'Please enter both username and password',
  'login.invalidResponse': 'Invalid response from server',
  'login.invalidCredentials': 'Invalid username or password',
  'login.failed': 'Failed to login. Please try again.',
  'login.about':
    'NPTLabs(TM) specializes in Mud Check in-loco, wherever and whenever our customers need. Drilling Fluid expectations require fast turn around laboratory tests. You can have access via our Mobile Laboratory or Full static lab services to have your particle size analysis and fluid testing now. We supply training, reporting systems, software, and personnel to the drilling industry. For over 25 years, E&P operators and service companies have relied on NPTLabs(TM) to deliver innovative and practical field solutions. Our ability to quantify performance with meaningful KPIs and to analyze data sets NPTLabs(TM) apart from others. Let us put our knowledge of drilling fluids, solids control, and drilling waste management to work for you.',
  'dashboard.eyebrow': 'Dashboard',
  'dashboard.title': 'Start with NPT Labs',
  'dashboard.summary':
    'Review generated results first, then jump into rig-well records, imported files, or a new mud check when fresh lab data arrives.',
  'dashboard.lastSevenDays': 'Last 7 days',
  'dashboard.resultsAdded': 'results added',
  'dashboard.lastUploadUnavailable': 'Last upload unavailable',
  'dashboard.lastUpload': 'Last upload: {{dateTime}}',
  'dashboard.noUploads': 'No uploads in this period',
  'dashboard.seeResults': 'See Results',
  'dashboard.mudCheckTitle': 'One-Click Mud Check',
  'dashboard.mudCheckDescription':
    'Upload a chemistry CSV and process well test results.',
  'dashboard.startUpload': 'Start upload',
  'dashboard.rigWellTitle': 'Rig-Well Directory',
  'dashboard.rigWellDescription':
    'Find a well and open its filtered Test Results page.',
  'dashboard.browseWells': 'Browse wells',
  'dashboard.importedFilesTitle': 'Imported Files',
  'dashboard.importedFilesDescription':
    'Review imported files and continue pending processing.',
  'dashboard.viewFiles': 'View files',
  'dashboard.centrifugeReportsDescription':
    'Review generated centrifuge performance reports.',
  'dashboard.viewCentrifugeReports': 'View reports',
  'rigWell.unknownRig': 'Unknown rig',
  'rigWell.loadError': 'Failed to load rig-well data',
  'rigWell.title': 'Operator, rig, and well directory',
  'rigWell.summary': 'Operators: {{operators}} · Wells: {{wells}}',
  'rigWell.search': 'Search operators, rigs, wells, or aliases',
  'rigWell.aliases': 'Aliases',
  'rigWell.rigCount': 'Rigs: {{count}}',
  'rigWell.wellCount': 'Wells: {{count}}',
  'rigWell.rig': 'Rig',
  'rigWell.well': 'Well',
  'rigWell.empty': 'No rig-well records available',
  'rigWell.goToResults': 'Go to Test Results',
  'results.measurementTakenAt': 'Measurement Taken at',
  'results.title': 'Test Results',
  'results.count': '{{count}} results',
  'results.columns': 'Columns',
  'results.columnsDescription': 'Show secondary columns',
  'results.resultId': 'Result ID',
  'results.selectPage': 'Select all results on this page',
  'results.selectResult': 'Select result {{id}}',
  'results.moreActions': 'More actions',
  'results.measurementPlaceholder': 'Filter by measurement date',
  'results.rigWellPlaceholder': 'Search rig - well',
  'results.allRigWells': 'All rigs / wells',
  'results.noRigWellMatches': 'No rig-well matches',
  'results.sampleSource': 'Sample Source',
  'results.sampleSourcePlaceholder': 'Search sample sources',
  'results.sampleSourcesSelected': '{{count}} selected',
  'results.noSampleSourceMatches': 'No sample source matches',
  'results.uploadedAt': 'Uploaded at',
  'results.uploadedPlaceholder': 'Filter by upload date',
  'results.clearFilters': 'Clear all filters',
  'results.instrumentSerial': 'Instrument Serial #',
  'results.readingNumber': 'Reading Number',
  'results.operator': 'Operator',
  'results.rigName': 'Rig Name',
  'results.wellName': 'Well Name',
  'results.empty': 'No reports available with current filters',
  'results.downloadReport': 'Download Report',
  'results.retortCalibration': 'Retort Calibration',
  'results.rerun': 'Rerun',
  'results.rerunSelected': 'Rerun selected ({{count}})',
  'results.rerunComplete': '{{count}} result(s) rerun successfully.',
  'results.rerunSkipped': '{{count}} selected result(s) were not eligible.',
  'results.rerunFailedCount': '{{count}} result(s) could not be rerun.',
  'results.noRerunnableSelected': 'No selected results have warning or failed QC.',
  'results.rerunError': 'Failed to rerun results',
  'results.exports': 'Exports',
  'results.selectionMeta': '{{selected}} selected / {{filtered}} filtered',
  'results.exportSelected': 'Export Selected ({{count}})',
  'results.exportFiltered': 'Export All Filtered ({{count}})',
  'results.exportFilteredAction': 'Export filtered',
  'results.selectedAcrossPages': '{{count}} selected across pages',
  'results.clearSelection': 'Clear selection',
  'results.rows': 'Rows',
  'results.rowsPerPage': 'Rows per page',
  'results.showing': 'Showing {{from}}-{{to}} of {{total}}',
  'results.status.pass': 'Pass',
  'results.status.warning': 'Warning',
  'results.status.fail': 'Fail',
  'results.loadingDates': 'Loading available dates',
  'results.reportsAvailable': 'Reports available',
  'results.reportsUploaded': 'Reports uploaded',
  'results.loadError': 'Failed to load data',
  'results.downloadError': 'Failed to download report',
  'results.pdfDownloadError': 'Failed to download PDF report',
  'results.csvFileName': 'results.csv',
  'results.pdfFileName': 'results_{{id}}.pdf',
  'results.wellLookupError': 'Failed to find well for calibration',
  'results.rigNotFound': 'Rig "{{rig}}" not found',
  'results.wellNotFound': 'Well "{{well}}" not found for rig "{{rig}}"',
  'centrifuge.report': 'Centrifuge Report',
  'centrifuge.reportsTitle': 'Centrifuge Reports',
  'centrifuge.reportsDescription': 'Review successful and failed centrifuge performance reports.',
  'centrifuge.count': '{{count}} reports',
  'centrifuge.showing': 'Showing {{from}}-{{to}} of {{total}}',
  'centrifuge.generate': 'Generate Centrifuge Report',
  'centrifuge.generateProgress': 'Generate Centrifuge Report ({{count}}/{{total}})',
  'centrifuge.generateTitle': 'Generate Centrifuge Report',
  'centrifuge.generateDescription': 'Enter the stream flows and one set of operating conditions for each centrifuge.',
  'centrifuge.generateDescriptionDual': 'Dual polishing uses two independent high-speed centrifuges. Enter each machine\'s measured suction and effluent flows; its discard is calculated automatically.',
  'centrifuge.loadingDefaults': 'Loading suggested values for this well...',
  'centrifuge.standardDefaults': 'Suggested starting values are pre-filled. Review them before generating the report.',
  'centrifuge.previousReportDefaults': 'Pre-filled from {{report}}, the latest report for this well. Review the values before generating.',
  'centrifuge.streamFlows': 'Measured Stream Flows',
  'centrifuge.flow': 'Flow',
  'centrifuge.operatingConditions': 'Operating Conditions',
  'centrifuge.gForce': 'G-force',
  'centrifuge.result': 'Result',
  'centrifuge.flowRange': 'greater than 0, up to 1,000 gpm',
  'centrifuge.flowValueError': 'Enter a flow greater than 0 and up to 1,000 gpm.',
  'centrifuge.lsFlowOrderError': 'LS Suction flow must be greater than LS Effluent flow.',
  'centrifuge.hsFlowOrderError': 'HS Effluent flow must be less than LS Effluent flow.',
  'centrifuge.hsFlowOrderWithDryingError': 'HS Effluent flow must be less than LS Effluent plus Drying Effluent flow.',
  'centrifuge.dualFlowOrderError': 'Centrifuge {{number}} Suction flow must be greater than its Effluent flow.',
  'centrifuge.valueRangeError': 'Enter a value within the allowed range.',
  'centrifuge.lowSpeed': 'Low Speed Centrifuge',
  'centrifuge.highSpeed': 'High Speed Centrifuge',
  'centrifuge.centrifuge1': 'Centrifuge 1',
  'centrifuge.centrifuge2': 'Centrifuge 2',
  'centrifuge.bowlSpeed': 'Bowl Speed, rpm',
  'centrifuge.bowlSpeedRange': 'Allowed range: 1-10,000 rpm',
  'centrifuge.backdrive': 'Backdrive Differential, rpm',
  'centrifuge.backdriveRange': 'Allowed range: 0-1,000 rpm',
  'centrifuge.bowlDiameter': 'Bowl Diameter, in',
  'centrifuge.bowlDiameterRange': 'Allowed range: 1-100 in',
  'centrifuge.role.ls_suction': 'LS Suction',
  'centrifuge.role.ls_effluent': 'LS Effluent',
  'centrifuge.role.drying_effluent': 'Drying Effluent',
  'centrifuge.role.hs_effluent': 'HS Effluent',
  'centrifuge.role.centrifuge_1_suction': 'Centrifuge 1 Suction',
  'centrifuge.role.centrifuge_1_effluent': 'Centrifuge 1 Effluent',
  'centrifuge.role.centrifuge_2_suction': 'Centrifuge 2 Suction',
  'centrifuge.role.centrifuge_2_effluent': 'Centrifuge 2 Effluent',
  'centrifuge.selectionCount': 'Select exactly three required measurements, plus optional Drying Effluent.',
  'centrifuge.selectionRoles': 'Select one LS Suction, one LS Effluent, one HS Effluent, and optionally one Drying Effluent.',
  'centrifuge.selectionDualRoles': 'Select one Suction and one Effluent measurement for each of Centrifuges 1 and 2.',
  'centrifuge.selectionMixedModes': 'Select measurements from either Barite Recovery or Dual Polishing, not both modes.',
  'centrifuge.selectionTooMany': 'Too many measurements selected across pages ({{count}}). A centrifuge report can use at most {{max}} measurements.',
  'centrifuge.selectionMissing': 'Missing: {{roles}}.',
  'centrifuge.selectionWell': 'All selected measurements must belong to the same rig and well.',
  'centrifuge.selectionAlreadyUsed': 'One or more selected results are already used by a centrifuge report.',
  'centrifuge.selectionReuse': 'Some selected measurements are linked to {{reports}}. Continue only if they should be linked to the new report instead.',
  'centrifuge.reuseTitle': 'Reuse linked measurements?',
  'centrifuge.reuseConfirm': 'Continue to report',
  'centrifuge.selectionUnavailable': 'Keep the selected measurements loaded before generating the report.',
  'centrifuge.createError': 'Failed to generate centrifuge report.',
  'centrifuge.loadError': 'Failed to load centrifuge reports.',
  'centrifuge.delete': 'Delete report',
  'centrifuge.deleteTitle': 'Delete {{report}}?',
  'centrifuge.deleteDescription': 'This removes the centrifuge report and clears measurement links that still point to it. This action cannot be undone.',
  'centrifuge.deleteConfirm': 'Delete report',
  'centrifuge.deleteError': 'Failed to delete centrifuge report.',
  'centrifuge.loadDetailError': 'Failed to load centrifuge report details.',
  'centrifuge.downloadError': 'Failed to download centrifuge report.',
  'centrifuge.createdAt': 'Created At',
  'centrifuge.measurements': 'Measurements',
  'centrifuge.bariteRecovery': 'Barite Recovery',
  'centrifuge.lgsRemoval': 'LGS Removal',
  'centrifuge.hgsRemoval': 'HGS Removal',
  'centrifuge.lsDensityCut': 'LS Density Cut',
  'centrifuge.hsDensityCut': 'HS Density Cut',
  'centrifuge.status': 'Status',
  'centrifuge.mode': 'Mode',
  'centrifuge.allModes': 'All modes',
  'centrifuge.modePlaceholder': 'Filter by mode',
  'centrifuge.createdPlaceholder': 'Filter by creation date',
  'centrifuge.mode.barite_recovery': 'Barite Recovery',
  'centrifuge.mode.dual_polishing': 'Dual Polishing',
  'centrifuge.centrifuge1LgsRemoval': 'C1 LGS Removal',
  'centrifuge.centrifuge1HgsRemoval': 'C1 HGS to Discard',
  'centrifuge.centrifuge1DensityCut': 'C1 Density Cut',
  'centrifuge.centrifuge2LgsRemoval': 'C2 LGS Removal',
  'centrifuge.centrifuge2HgsRemoval': 'C2 HGS to Discard',
  'centrifuge.centrifuge2DensityCut': 'C2 Density Cut',
  'centrifuge.statusCalculated': 'Calculated',
  'centrifuge.statusCalculatedWithWarnings': 'Calculated with warnings',
  'centrifuge.statusCalculatedWithoutDrying': 'Calculated without Drying Effluent',
  'centrifuge.statusFailed': 'Failed',
  'centrifuge.calculationFailed': 'Calculation failed',
  'centrifuge.empty': 'No centrifuge reports are available.',
  'centrifuge.view': 'View report',
  'centrifuge.download': 'Download PDF',
  'centrifuge.pdfUnavailable': 'PDF is unavailable because the calculation failed.',
  'centrifuge.warnings': 'Calculation Warnings',
  'centrifuge.warning.componentClosure': '{{role}} component closure is {{value}}%.',
  'centrifuge.warning.failedQaqc': '{{role}} failed QA/QC but is included in this performance run calculation.',
  'centrifuge.warning.qaqc': '{{role}} has a QA/QC warning.',
  'centrifuge.warning.densityNotDecreased': '{{role}} density did not decrease from suction.',
  'centrifuge.warning.lgsNotDecreased': '{{role}} LGS did not decrease from suction.',
  'centrifuge.warning.retakeExcluded': '{{role}} retake was excluded: {{reason}}',
  'imports.fileName': 'File Name',
  'imports.title': 'Imported Files',
  'imports.count': '{{count}} files',
  'imports.showing': 'Showing {{from}}-{{to}} of {{total}}',
  'imports.source': 'Source',
  'imports.allSources': 'All sources',
  'imports.sourceDesktopApp': 'Desktop app',
  'imports.desktopAppVersion': 'Desktop app version: {{version}}',
  'imports.sourceWebApp': 'Web app',
  'imports.sourceDirectApi': 'Direct API',
  'imports.sourceSharePoint': 'SharePoint',
  'imports.sourceApiRerun': 'API rerun',
  'imports.sourceLegacyUnknown': 'Unknown (legacy)',
  'imports.status': 'Status',
  'imports.size': 'Size',
  'imports.records': 'Records',
  'imports.total': 'Total',
  'imports.totalRecords': 'Total Records',
  'imports.processed': 'Processed',
  'imports.duplicates': 'Duplicates',
  'imports.uploadedAt': 'Uploaded At',
  'imports.uploadedPlaceholder': 'Filter by upload date',
  'imports.filesUploaded': 'Files uploaded',
  'imports.sourcePlaceholder': 'Filter by source',
  'imports.empty': 'No import files available',
  'imports.download': 'Download',
  'imports.process': 'Process',
  'imports.alreadyProcessed': 'Already processed',
  'imports.loadError': 'Failed to load import files',
  'imports.downloadError': 'Failed to download file',
  'imports.statusProcessed': 'Processed',
  'imports.statusImported': 'Imported',
  'imports.statusFailed': 'Failed',
  'imports.statusUnknown': 'Unknown',
  'imports.viewError': 'View error',
  'imports.viewWarnings': 'View warnings',
  'imports.diagnosticsTitle': 'Import processing details',
  'imports.noDiagnostics': 'No details recorded',
  'upload.description': 'Upload a CSV file with chemistry data to process well test results.',
  'upload.selectFile': 'Select a file',
  'upload.loadingFile': 'Loading file...',
  'upload.chooseFile': 'Click to choose file',
  'upload.fileTooLarge': 'The file is too large (max 5 MB)',
  'upload.selected': 'Selected: {{name}} ({{size}} KB)',
  'upload.allowDuplicates': 'Allow duplicates',
  'upload.submit': 'Upload selected file',
  'upload.recordsProcessed': '({{count}} records processed, {{duplicates}} duplicates inserted)',
  'upload.measurementTimeAdjusted':
    'Adjusted measurement time for {{count}} record(s): the uploaded timestamp was more than one month from the server time, so it was replaced with the current Argentina time (GMT-3).',
  'upload.rowsSkipped': '{{count}} row(s) could not be processed',
  'upload.moreErrors': 'And {{count}} more error(s).',
  'upload.viewResult': 'View Result',
  'upload.here': 'here',
  'upload.importLoadError': 'Failed to load file from import files',
  'upload.failed': 'Failed to upload file. Please try again.',
  'upload.duplicatesDetected': 'Duplicates have been detected! Count: {{count}}',
  'upload.invalidFormat': 'Invalid file format! Please check the file format and retry.',
  'upload.processingFailed': 'Failed to process CSV. Please check the file format.',
  'upload.serverError': 'Server Error: {{message}}',
  'upload.unknownError': 'Unknown error',
  'calibration.invalidRigId': 'Invalid rig ID',
  'calibration.title': 'Retort Calibration',
  'calibration.backToResults': 'Back to Test Results',
  'calibration.rig': 'Rig',
  'calibration.settingsDescription': 'Saved factors applied to new results for this rig.',
  'calibration.rigName': 'Rig Name: {{name}}',
  'calibration.retortHistoryWell': 'Retort history well',
  'calibration.selectWell': 'Select a well',
  'calibration.noWells': 'No wells found',
  'calibration.factors': 'Calibration factors',
  'calibration.saved': 'Calibration saved successfully',
  'calibration.validationError': 'Validation Error',
  'calibration.oilPercent': 'Oil%',
  'calibration.waterPercent': 'Water%',
  'calibration.retortStep': '1. Enter or select a retort',
  'calibration.testStep': '2. Select a test result',
  'calibration.applyStep': '3. Apply a calibration',
  'calibration.mudDensity': 'Mud Density',
  'calibration.selectSampleSource': 'Select sample source',
  'calibration.saveRetort': 'Save retort',
  'calibration.date': 'Date',
  'calibration.density': 'Density',
  'calibration.delete': 'Delete',
  'calibration.noRetortHistory': 'No retort history found for this well',
  'calibration.fillAllFields':
    'Please fill all fields (Density, Oil%, Water%, Sample Source)',
  'calibration.loadRetortError': 'Failed to load retort history',
  'calibration.addRetortError': 'Failed to add retort history entry',
  'calibration.deleteRetortError': 'Failed to delete retort history entry',
  'calibration.unauthorized': 'Unauthorized. Please log in again.',
  'calibration.accessDenied': 'Access denied. Please contact your administrator.',
  'calibration.rigNotFound': 'Rig not found',
  'calibration.saveError': 'Failed to save calibration',
  'calibration.loadError': 'Failed to load calibration',
  'calibration.rangePercent': 'Range: 0-100',
  'calibration.matchingSourceHint':
    'Please select a test result with a sample source matching the retort chosen above',
  'calibration.well': 'Well',
  'calibration.predictedOil': 'Predicted Oil %',
  'calibration.predictedWater': 'Predicted Water %',
  'calibration.calibratedOil': 'Calibrated Oil %',
  'calibration.calibratedWater': 'Calibrated Water %',
  'calibration.noTestResults': 'No test results found for this rig',
  'calibration.loadTestResultsError': 'Failed to load test results',
  'calibration.oilFactor': 'Oil Calibration Factor',
  'calibration.waterFactor': 'Water Calibration Factor',
  'calibration.selectRetortAndResult': 'Please select Retort and Test Result',
  'calibration.formula': '(Predicted {{kind}}% - Retort {{kind}}%)',
  'calibration.target': 'Target:',
  'calibration.selectRetortSource': 'Select retort with source',
  'calibration.apply': 'Apply',
  'page404.message': 'Page not found',
  'page404.description': 'The page may have moved, or the address may be incorrect.',
  'page404.home': 'Back to Home',
} as const;

export type TranslationKey = keyof typeof englishTranslations;

export const spanishTranslations: Record<TranslationKey, string> = {
  'language.label': 'Idioma',
  'language.english': 'Inglés',
  'language.spanish': 'Español',
  'common.actions': 'Acciones',
  'common.cancel': 'Cancelar',
  'common.close': 'Cerrar',
  'common.error': 'Error',
  'common.failed': 'Fallidos',
  'common.loading': 'Cargando',
  'common.save': 'Guardar',
  'common.success': 'Correcto',
  'common.unknown': 'Desconocido',
  'common.user': 'Usuario',
  'common.unknownCompany': 'Empresa desconocida',
  'nav.home': 'Inicio',
  'nav.primary': 'Navegación principal',
  'nav.rigWell': 'Equipo-Pozo',
  'nav.testResults': 'Resultados',
  'nav.centrifugeReports': 'Informes de centrífuga',
  'nav.importedFiles': 'Archivos importados',
  'header.createApiToken': 'Crear token de API',
  'header.companySettings': 'Configuración de la empresa',
  'header.oneClickMudCheck': 'Control de lodo en un clic',
  'header.uploadCsv': 'Cargar CSV',
  'header.downloadDesktopApp': 'Descargar aplicación de escritorio',
  'header.downloadingDesktopApp': 'Descargando aplicación de escritorio…',
  'header.downloadDesktopAppError': 'No se pudo descargar la aplicación de escritorio. Inténtelo de nuevo.',
  'header.logout': 'Cerrar sesión',
  'header.calibration': 'Calibración',
  'header.qc': 'QC',
  'header.qcThresholds': 'Límites de QC',
  'header.qcThresholdsDescription':
    'Límites de QC de la empresa para resultados nuevos. Los resultados existentes no se recalculan.',
  'header.oilCalibration': 'Calibración de aceite %',
  'header.waterCalibration': 'Calibración de agua %',
  'header.oilCalibrationDescription':
    'Resta estos puntos porcentuales del aceite % previsto para resultados nuevos de esta empresa. Los resultados existentes no se recalculan.',
  'header.waterCalibrationDescription':
    'Resta estos puntos porcentuales del agua % prevista para resultados nuevos de esta empresa. Los resultados existentes no se recalculan.',
  'header.resetDefault': 'Restablecer valor predeterminado',
  'header.resetFieldDefault': 'Restablecer {{field}} al valor predeterminado',
  'header.loadSettingsError': 'No se pudo cargar la configuración de la empresa.',
  'header.saveSettingsError': 'No se pudo guardar la configuración de la empresa.',
  'header.numberError': 'La calibración {{label}} debe ser un número.',
  'header.rangeError': 'La calibración {{label}} debe estar entre -100 y 100.',
  'header.fieldNumberError': '{{field}} debe ser un número.',
  'header.fieldMinError': '{{field}} debe ser al menos {{min}}.',
  'header.fieldMaxError': '{{field}} debe ser como máximo {{max}}.',
  'header.warningBandDescription':
    '0,15 representa el 15 % de la distancia entre los límites inferior y superior.',
  'header.apiTokenTitle': 'Crear token de API',
  'header.apiTokenError': 'No se pudo crear el token de API.',
  'header.apiTokenDescription':
    'Pegue este token en el campo Token de autenticación de la configuración de API de la aplicación Qt.',
  'header.copied': 'Copiado',
  'header.copyToken': 'Copiar token',
  'login.title': 'Iniciar sesión',
  'login.subtitle': 'Bienvenido de nuevo. Introduzca sus datos.',
  'login.name': 'Nombre',
  'login.password': 'Contraseña',
  'login.signIn': 'Iniciar sesión',
  'login.missingCredentials': 'Introduzca el nombre de usuario y la contrasena',
  'login.invalidResponse': 'Respuesta no válida del servidor',
  'login.invalidCredentials': 'Nombre de usuario o contraseña no válidos',
  'login.failed': 'No se pudo iniciar sesión. Inténtelo de nuevo.',
  'login.about':
    'NPTLabs(TM) se especializa en controles de lodo in situ, donde y cuando nuestros clientes los necesiten. Las exigencias de los fluidos de perforación requieren análisis de laboratorio rápidos. Puede acceder a nuestros servicios mediante el laboratorio móvil o nuestros laboratorios estáticos completos para obtener ahora análisis del tamaño de partículas y pruebas de fluidos. Proporcionamos capacitación, sistemas de informes, software y personal para la industria de perforación. Durante más de 25 años, operadores de E&P y empresas de servicios han confiado en NPTLabs(TM) para ofrecer soluciones de campo innovadoras y prácticas. Nuestra capacidad para cuantificar el rendimiento con KPI significativos y analizar conjuntos de datos distingue a NPTLabs(TM). Pongamos a su servicio nuestro conocimiento de fluidos de perforación, control de sólidos y gestión de residuos de perforación.',
  'dashboard.eyebrow': 'Panel',
  'dashboard.title': 'Comience con NPT Labs',
  'dashboard.summary':
    'Revise primero los resultados generados y luego acceda a los registros de equipos y pozos, archivos importados o un nuevo control de lodo cuando lleguen datos nuevos del laboratorio.',
  'dashboard.lastSevenDays': 'Últimos 7 días',
  'dashboard.resultsAdded': 'resultados agregados',
  'dashboard.lastUploadUnavailable': 'Última carga no disponible',
  'dashboard.lastUpload': 'Última carga: {{dateTime}}',
  'dashboard.noUploads': 'No hay cargas en este período',
  'dashboard.seeResults': 'Ver resultados',
  'dashboard.mudCheckTitle': 'Control de lodo en un clic',
  'dashboard.mudCheckDescription':
    'Cargue un CSV de química y procese los resultados de las pruebas del pozo.',
  'dashboard.startUpload': 'Iniciar carga',
  'dashboard.rigWellTitle': 'Directorio de equipos y pozos',
  'dashboard.rigWellDescription':
    'Busque un pozo y abra la página de resultados filtrada.',
  'dashboard.browseWells': 'Explorar pozos',
  'dashboard.importedFilesTitle': 'Archivos importados',
  'dashboard.importedFilesDescription':
    'Revise los archivos importados y continúe el procesamiento pendiente.',
  'dashboard.viewFiles': 'Ver archivos',
  'dashboard.centrifugeReportsDescription':
    'Revise los informes generados de rendimiento de centrífuga.',
  'dashboard.viewCentrifugeReports': 'Ver informes',
  'rigWell.unknownRig': 'Equipo desconocido',
  'rigWell.loadError': 'No se pudieron cargar los datos de equipos y pozos',
  'rigWell.title': 'Directorio de operadores, equipos y pozos',
  'rigWell.summary': 'Operadores: {{operators}} · Pozos: {{wells}}',
  'rigWell.search': 'Buscar operadores, equipos, pozos o alias',
  'rigWell.aliases': 'Alias',
  'rigWell.rigCount': 'Equipos: {{count}}',
  'rigWell.wellCount': 'Pozos: {{count}}',
  'rigWell.rig': 'Equipo',
  'rigWell.well': 'Pozo',
  'rigWell.empty': 'No hay registros de equipos y pozos disponibles',
  'rigWell.goToResults': 'Ir a resultados',
  'results.measurementTakenAt': 'Fecha de medición',
  'results.title': 'Resultados',
  'results.count': '{{count}} resultados',
  'results.columns': 'Columnas',
  'results.columnsDescription': 'Mostrar columnas secundarias',
  'results.resultId': 'ID de resultado',
  'results.selectPage': 'Seleccionar todos los resultados de esta página',
  'results.selectResult': 'Seleccionar resultado {{id}}',
  'results.moreActions': 'Más acciones',
  'results.measurementPlaceholder': 'Filtrar por fecha de medición',
  'results.rigWellPlaceholder': 'Buscar equipo - pozo',
  'results.allRigWells': 'Todos los equipos / pozos',
  'results.noRigWellMatches': 'No hay coincidencias de equipos y pozos',
  'results.sampleSource': 'Origen de muestra',
  'results.sampleSourcePlaceholder': 'Buscar orígenes de muestra',
  'results.sampleSourcesSelected': '{{count}} seleccionados',
  'results.noSampleSourceMatches': 'No hay coincidencias de origen de muestra',
  'results.uploadedAt': 'Fecha de carga',
  'results.uploadedPlaceholder': 'Filtrar por fecha de carga',
  'results.clearFilters': 'Borrar todos los filtros',
  'results.instrumentSerial': 'N. de serie del instrumento',
  'results.readingNumber': 'Número de lectura',
  'results.operator': 'Operador',
  'results.rigName': 'Nombre del equipo',
  'results.wellName': 'Nombre del pozo',
  'results.empty': 'No hay informes disponibles con los filtros actuales',
  'results.downloadReport': 'Descargar informe',
  'results.retortCalibration': 'Calibración de retorta',
  'results.rerun': 'Repetir',
  'results.rerunSelected': 'Repetir seleccionados ({{count}})',
  'results.rerunComplete': '{{count}} resultado(s) repetidos correctamente.',
  'results.rerunSkipped': '{{count}} resultado(s) seleccionados no eran elegibles.',
  'results.rerunFailedCount': 'No se pudieron repetir {{count}} resultado(s).',
  'results.noRerunnableSelected': 'Ningún resultado seleccionado tiene QC de advertencia o fallido.',
  'results.rerunError': 'No se pudieron repetir los resultados',
  'results.exports': 'Exportaciones',
  'results.selectionMeta': '{{selected}} seleccionados / {{filtered}} filtrados',
  'results.exportSelected': 'Exportar seleccionados ({{count}})',
  'results.exportFiltered': 'Exportar todos los filtrados ({{count}})',
  'results.exportFilteredAction': 'Exportar filtrados',
  'results.selectedAcrossPages': '{{count}} seleccionados entre páginas',
  'results.clearSelection': 'Borrar selección',
  'results.rows': 'Filas',
  'results.rowsPerPage': 'Filas por página',
  'results.showing': 'Mostrando {{from}}-{{to}} de {{total}}',
  'results.status.pass': 'Aprobado',
  'results.status.warning': 'Advertencia',
  'results.status.fail': 'Fallido',
  'results.loadingDates': 'Cargando fechas disponibles',
  'results.reportsAvailable': 'Informes disponibles',
  'results.reportsUploaded': 'Informes cargados',
  'results.loadError': 'No se pudieron cargar los datos',
  'results.downloadError': 'No se pudo descargar el informe',
  'results.pdfDownloadError': 'No se pudo descargar el informe PDF',
  'results.csvFileName': 'resultados.csv',
  'results.pdfFileName': 'resultados_{{id}}.pdf',
  'results.wellLookupError': 'No se pudo encontrar el pozo para la calibración',
  'results.rigNotFound': 'No se encontró el equipo "{{rig}}"',
  'results.wellNotFound': 'No se encontró el pozo "{{well}}" para el equipo "{{rig}}"',
  'centrifuge.report': 'Informe de centrífuga',
  'centrifuge.reportsTitle': 'Informes de centrífuga',
  'centrifuge.reportsDescription': 'Revise los informes de rendimiento de centrífuga correctos y fallidos.',
  'centrifuge.count': '{{count}} informes',
  'centrifuge.showing': 'Mostrando {{from}}-{{to}} de {{total}}',
  'centrifuge.generate': 'Generar informe de centrífuga',
  'centrifuge.generateProgress': 'Generar informe de centrífuga ({{count}}/{{total}})',
  'centrifuge.generateTitle': 'Generar informe de centrífuga',
  'centrifuge.generateDescription': 'Ingrese los caudales y un conjunto de condiciones operativas para cada centrífuga.',
  'centrifuge.generateDescriptionDual': 'El pulido dual usa dos centrífugas independientes de alta velocidad. Ingrese los caudales medidos de succión y efluente de cada máquina; su descarte se calcula automáticamente.',
  'centrifuge.loadingDefaults': 'Cargando valores sugeridos para este pozo...',
  'centrifuge.standardDefaults': 'Los valores iniciales sugeridos están precargados. Revíselos antes de generar el informe.',
  'centrifuge.previousReportDefaults': 'Precargado desde {{report}}, el informe más reciente de este pozo. Revise los valores antes de generar.',
  'centrifuge.streamFlows': 'Caudales medidos',
  'centrifuge.flow': 'Caudal',
  'centrifuge.operatingConditions': 'Condiciones operativas',
  'centrifuge.gForce': 'Fuerza G',
  'centrifuge.result': 'Resultado',
  'centrifuge.flowRange': 'mayor que 0 y hasta 1.000 gpm',
  'centrifuge.flowValueError': 'Ingrese un caudal mayor que 0 y de hasta 1.000 gpm.',
  'centrifuge.lsFlowOrderError': 'El caudal de succión LS debe ser mayor que el caudal del efluente LS.',
  'centrifuge.hsFlowOrderError': 'El caudal del efluente HS debe ser menor que el caudal del efluente LS.',
  'centrifuge.hsFlowOrderWithDryingError': 'El caudal del efluente HS debe ser menor que la suma de los caudales del efluente LS y del efluente de secado.',
  'centrifuge.dualFlowOrderError': 'El caudal de succión de la centrífuga {{number}} debe ser mayor que su caudal de efluente.',
  'centrifuge.valueRangeError': 'Ingrese un valor dentro del rango permitido.',
  'centrifuge.lowSpeed': 'Centrífuga de baja velocidad',
  'centrifuge.highSpeed': 'Centrífuga de alta velocidad',
  'centrifuge.centrifuge1': 'Centrífuga 1',
  'centrifuge.centrifuge2': 'Centrífuga 2',
  'centrifuge.bowlSpeed': 'Velocidad del tazón, rpm',
  'centrifuge.bowlSpeedRange': 'Rango permitido: 1-10.000 rpm',
  'centrifuge.backdrive': 'Diferencial de backdrive, rpm',
  'centrifuge.backdriveRange': 'Rango permitido: 0-1.000 rpm',
  'centrifuge.bowlDiameter': 'Diámetro del tazón, in',
  'centrifuge.bowlDiameterRange': 'Rango permitido: 1-100 in',
  'centrifuge.role.ls_suction': 'Succión LS',
  'centrifuge.role.ls_effluent': 'Efluente LS',
  'centrifuge.role.drying_effluent': 'Efluente de secado',
  'centrifuge.role.hs_effluent': 'Efluente HS',
  'centrifuge.role.centrifuge_1_suction': 'Entrada decanter 1',
  'centrifuge.role.centrifuge_1_effluent': 'Salida líquida decanter 1',
  'centrifuge.role.centrifuge_2_suction': 'Entrada decanter 2',
  'centrifuge.role.centrifuge_2_effluent': 'Salida líquida decanter 2',
  'centrifuge.selectionCount': 'Seleccione exactamente las tres mediciones obligatorias y, opcionalmente, el efluente de secado.',
  'centrifuge.selectionRoles': 'Seleccione una succión LS, un efluente LS, un efluente HS y, opcionalmente, un efluente de secado.',
  'centrifuge.selectionDualRoles': 'Seleccione una medición de succión y una de efluente para cada una de las centrífugas 1 y 2.',
  'centrifuge.selectionMixedModes': 'Seleccione mediciones de Recuperación de Barita o de Pulido Dual, no de ambos modos.',
  'centrifuge.selectionTooMany': 'Hay demasiadas mediciones seleccionadas entre las páginas ({{count}}). Un informe de centrífuga puede usar como máximo {{max}} mediciones.',
  'centrifuge.selectionMissing': 'Falta: {{roles}}.',
  'centrifuge.selectionWell': 'Todas las mediciones seleccionadas deben pertenecer al mismo equipo y pozo.',
  'centrifuge.selectionAlreadyUsed': 'Uno o más resultados ya se usan en un informe de centrífuga.',
  'centrifuge.selectionReuse': 'Algunas mediciones seleccionadas están vinculadas a {{reports}}. Continúe solo si deben vincularse al nuevo informe.',
  'centrifuge.reuseTitle': '¿Reutilizar mediciones vinculadas?',
  'centrifuge.reuseConfirm': 'Continuar al informe',
  'centrifuge.selectionUnavailable': 'Mantenga cargadas las mediciones seleccionadas antes de generar el informe.',
  'centrifuge.createError': 'No se pudo generar el informe de centrífuga.',
  'centrifuge.loadError': 'No se pudieron cargar los informes de centrífuga.',
  'centrifuge.delete': 'Eliminar informe',
  'centrifuge.deleteTitle': '¿Eliminar {{report}}?',
  'centrifuge.deleteDescription': 'Esto elimina el informe de centrífuga y borra los vínculos de mediciones que aún apuntan a él. Esta acción no se puede deshacer.',
  'centrifuge.deleteConfirm': 'Eliminar informe',
  'centrifuge.deleteError': 'No se pudo eliminar el informe de centrífuga.',
  'centrifuge.loadDetailError': 'No se pudieron cargar los detalles del informe de centrífuga.',
  'centrifuge.downloadError': 'No se pudo descargar el informe de centrífuga.',
  'centrifuge.createdAt': 'Creado',
  'centrifuge.measurements': 'Mediciones',
  'centrifuge.bariteRecovery': 'Recuperación de barita',
  'centrifuge.lgsRemoval': 'Remoción de LGS',
  'centrifuge.hgsRemoval': 'Remoción de HGS',
  'centrifuge.lsDensityCut': 'Corte de densidad LS',
  'centrifuge.hsDensityCut': 'Corte de densidad HS',
  'centrifuge.status': 'Estado',
  'centrifuge.mode': 'Modo',
  'centrifuge.allModes': 'Todos los modos',
  'centrifuge.modePlaceholder': 'Filtrar por modo',
  'centrifuge.createdPlaceholder': 'Filtrar por fecha de creación',
  'centrifuge.mode.barite_recovery': 'Recuperación de Barita',
  'centrifuge.mode.dual_polishing': 'Pulido Dual',
  'centrifuge.centrifuge1LgsRemoval': 'Remoción LGS C1',
  'centrifuge.centrifuge1HgsRemoval': 'HGS a descarte C1',
  'centrifuge.centrifuge1DensityCut': 'Corte de densidad C1',
  'centrifuge.centrifuge2LgsRemoval': 'Remoción LGS C2',
  'centrifuge.centrifuge2HgsRemoval': 'HGS a descarte C2',
  'centrifuge.centrifuge2DensityCut': 'Corte de densidad C2',
  'centrifuge.statusCalculated': 'Calculado',
  'centrifuge.statusCalculatedWithWarnings': 'Calculado con advertencias',
  'centrifuge.statusCalculatedWithoutDrying': 'Calculado sin efluente de secado',
  'centrifuge.statusFailed': 'Fallido',
  'centrifuge.calculationFailed': 'El cálculo falló',
  'centrifuge.empty': 'No hay informes de centrífuga disponibles.',
  'centrifuge.view': 'Ver informe',
  'centrifuge.download': 'Descargar PDF',
  'centrifuge.pdfUnavailable': 'El PDF no está disponible porque el cálculo falló.',
  'centrifuge.warnings': 'Advertencias de cálculo',
  'centrifuge.warning.componentClosure': 'El cierre de componentes de {{role}} es {{value}} %.',
  'centrifuge.warning.failedQaqc': '{{role}} no aprobó QA/QC, pero se incluye en el cálculo de esta ejecución de rendimiento.',
  'centrifuge.warning.qaqc': '{{role}} tiene una advertencia de QA/QC.',
  'centrifuge.warning.densityNotDecreased': 'La densidad de {{role}} no disminuyó con respecto a la entrada.',
  'centrifuge.warning.lgsNotDecreased': 'Los LGS de {{role}} no disminuyeron con respecto a la entrada.',
  'centrifuge.warning.retakeExcluded': 'Se excluyó la repetición de {{role}}: {{reason}}',
  'imports.fileName': 'Nombre del archivo',
  'imports.title': 'Archivos importados',
  'imports.count': '{{count}} archivos',
  'imports.showing': 'Mostrando {{from}}-{{to}} de {{total}}',
  'imports.source': 'Origen',
  'imports.allSources': 'Todos los orígenes',
  'imports.sourceDesktopApp': 'Aplicación de escritorio',
  'imports.desktopAppVersion': 'Versión de la aplicación de escritorio: {{version}}',
  'imports.sourceWebApp': 'Aplicación web',
  'imports.sourceDirectApi': 'API directa',
  'imports.sourceSharePoint': 'SharePoint',
  'imports.sourceApiRerun': 'Reprocesamiento de API',
  'imports.sourceLegacyUnknown': 'Desconocido (heredado)',
  'imports.status': 'Estado',
  'imports.size': 'Tamaño',
  'imports.records': 'Registros',
  'imports.total': 'Total',
  'imports.totalRecords': 'Registros totales',
  'imports.processed': 'Procesados',
  'imports.duplicates': 'Duplicados',
  'imports.uploadedAt': 'Fecha de carga',
  'imports.uploadedPlaceholder': 'Filtrar por fecha de carga',
  'imports.filesUploaded': 'Archivos cargados',
  'imports.sourcePlaceholder': 'Filtrar por origen',
  'imports.empty': 'No hay archivos importados disponibles',
  'imports.download': 'Descargar',
  'imports.process': 'Procesar',
  'imports.alreadyProcessed': 'Ya procesado',
  'imports.loadError': 'No se pudieron cargar los archivos importados',
  'imports.downloadError': 'No se pudo descargar el archivo',
  'imports.statusProcessed': 'Procesado',
  'imports.statusImported': 'Importado',
  'imports.statusFailed': 'Fallido',
  'imports.statusUnknown': 'Desconocido',
  'imports.viewError': 'Ver error',
  'imports.viewWarnings': 'Ver advertencias',
  'imports.diagnosticsTitle': 'Detalles del procesamiento de la importación',
  'imports.noDiagnostics': 'Sin detalles registrados',
  'upload.description': 'Cargue un archivo CSV con datos químicos para procesar los resultados de las pruebas del pozo.',
  'upload.selectFile': 'Seleccione un archivo',
  'upload.loadingFile': 'Cargando archivo...',
  'upload.chooseFile': 'Haga clic para elegir un archivo',
  'upload.fileTooLarge': 'El archivo es demasiado grande (máximo 5 MB)',
  'upload.selected': 'Seleccionado: {{name}} ({{size}} KB)',
  'upload.allowDuplicates': 'Permitir duplicados',
  'upload.submit': 'Cargar archivo seleccionado',
  'upload.recordsProcessed': '({{count}} registros procesados, {{duplicates}} duplicados insertados)',
  'upload.measurementTimeAdjusted':
    'Se ajustó la hora de medición de {{count}} registro(s): la fecha y hora cargadas diferían en más de un mes de la hora del servidor, por lo que se reemplazaron con la hora actual de Argentina (GMT-3).',
  'upload.rowsSkipped': 'No se pudieron procesar {{count}} fila(s)',
  'upload.moreErrors': 'Y {{count}} error(es) más.',
  'upload.viewResult': 'Ver resultado',
  'upload.here': 'aquí',
  'upload.importLoadError': 'No se pudo cargar el archivo desde archivos importados',
  'upload.failed': 'No se pudo cargar el archivo. Inténtelo de nuevo.',
  'upload.duplicatesDetected': 'Se detectaron duplicados. Cantidad: {{count}}',
  'upload.invalidFormat': 'Formato de archivo no válido. Compruebe el formato e inténtelo de nuevo.',
  'upload.processingFailed': 'No se pudo procesar el CSV. Compruebe el formato del archivo.',
  'upload.serverError': 'Error del servidor: {{message}}',
  'upload.unknownError': 'Error desconocido',
  'calibration.invalidRigId': 'ID de equipo no válido',
  'calibration.title': 'Calibración de retorta',
  'calibration.backToResults': 'Volver a resultados',
  'calibration.rig': 'Equipo',
  'calibration.settingsDescription': 'Factores guardados que se aplican a los nuevos resultados de este equipo.',
  'calibration.rigName': 'Nombre del equipo: {{name}}',
  'calibration.retortHistoryWell': 'Pozo del historial de retorta',
  'calibration.selectWell': 'Seleccione un pozo',
  'calibration.noWells': 'No se encontraron pozos',
  'calibration.factors': 'Factores de calibración',
  'calibration.saved': 'Calibración guardada correctamente',
  'calibration.validationError': 'Error de validación',
  'calibration.oilPercent': 'Aceite %',
  'calibration.waterPercent': 'Agua %',
  'calibration.retortStep': '1. Introduzca o seleccione una retorta',
  'calibration.testStep': '2. Seleccione un resultado de prueba',
  'calibration.applyStep': '3. Aplique una calibración',
  'calibration.mudDensity': 'Densidad del lodo',
  'calibration.selectSampleSource': 'Seleccione el origen de muestra',
  'calibration.saveRetort': 'Guardar retorta',
  'calibration.date': 'Fecha',
  'calibration.density': 'Densidad',
  'calibration.delete': 'Eliminar',
  'calibration.noRetortHistory': 'No hay historial de retorta para este pozo',
  'calibration.fillAllFields':
    'Complete todos los campos (Densidad, Aceite %, Agua %, Origen de muestra)',
  'calibration.loadRetortError': 'No se pudo cargar el historial de retorta',
  'calibration.addRetortError': 'No se pudo agregar la entrada al historial de retorta',
  'calibration.deleteRetortError': 'No se pudo eliminar la entrada del historial de retorta',
  'calibration.unauthorized': 'No autorizado. Inicie sesión de nuevo.',
  'calibration.accessDenied': 'Acceso denegado. Contacte con su administrador.',
  'calibration.rigNotFound': 'Equipo no encontrado',
  'calibration.saveError': 'No se pudo guardar la calibración',
  'calibration.loadError': 'No se pudo cargar la calibración',
  'calibration.rangePercent': 'Rango: 0-100',
  'calibration.matchingSourceHint':
    'Seleccione un resultado con el mismo origen de muestra que la retorta elegida arriba',
  'calibration.well': 'Pozo',
  'calibration.predictedOil': 'Aceite previsto %',
  'calibration.predictedWater': 'Agua prevista %',
  'calibration.calibratedOil': 'Aceite calibrado %',
  'calibration.calibratedWater': 'Agua calibrada %',
  'calibration.noTestResults': 'No se encontraron resultados para este equipo',
  'calibration.loadTestResultsError': 'No se pudieron cargar los resultados de prueba',
  'calibration.oilFactor': 'Factor de calibración de aceite',
  'calibration.waterFactor': 'Factor de calibración de agua',
  'calibration.selectRetortAndResult': 'Seleccione una retorta y un resultado de prueba',
  'calibration.formula': '(% de {{kind}} previsto - % de {{kind}} de retorta)',
  'calibration.target': 'Destino:',
  'calibration.selectRetortSource': 'Seleccione una retorta con origen',
  'calibration.apply': 'Aplicar',
  'page404.message': 'Página no encontrada',
  'page404.description': 'Es posible que la página se haya movido o que la dirección sea incorrecta.',
  'page404.home': 'Volver al inicio',
};
